// extracted by mini-css-extract-plugin
module.exports = {"container":"MessageBox_container__1pIE7","button-container":"MessageBox_button-container__34h1u","submit-button":"MessageBox_submit-button__3gH_A"};